(function(){
'use strict';
if(window.__kdkBeautyVitrine2026)return;
window.__kdkBeautyVitrine2026=true;
function init(){
  var root=document.querySelector('[data-kdk-beauty-root]');
  if(!root)return;
  document.body.classList.add('kdk-beauty-page');
  if(root.dataset.beautyReady==='1')return;
  root.dataset.beautyReady='1';
  var rail=root.querySelector('[data-beauty-rail]');
  if(!rail)return;
  var prev=root.querySelector('[data-beauty-prev]');
  var next=root.querySelector('[data-beauty-next]');
  var fill=root.querySelector('[data-beauty-progress] span');
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inView=false,paused=false;
  function update(){
    if(!fill)return;
    var max=Math.max(1,rail.scrollWidth-rail.clientWidth);
    var ratio=Math.max(0,Math.min(1,rail.scrollLeft/max));
    fill.style.transform='translateX('+(ratio*240)+'%)';
  }
  function advance(direction){
    var item=rail.querySelector('.kb-product');
    var step=item?item.getBoundingClientRect().width+12:215;
    var max=Math.max(0,rail.scrollWidth-rail.clientWidth);
    if(max<=4)return;
    var proposed=rail.scrollLeft+step*direction;
    var dest=proposed>=max-4?0:proposed<=-1?max:proposed;
    rail.scrollTo({left:dest,behavior:reduced?'auto':'smooth'});
  }
  if(prev)prev.addEventListener('click',function(){paused=true;advance(-1);});
  if(next)next.addEventListener('click',function(){paused=true;advance(1);});
  rail.addEventListener('scroll',update,{passive:true});
  rail.addEventListener('pointerenter',function(){paused=true;},{passive:true});
  rail.addEventListener('pointerleave',function(){paused=false;},{passive:true});
  rail.addEventListener('focusin',function(){paused=true;});
  rail.addEventListener('focusout',function(){paused=false;});
  rail.addEventListener('touchstart',function(){paused=true;},{passive:true});
  rail.addEventListener('touchend',function(){paused=false;},{passive:true});
  if('IntersectionObserver'in window){
    var observer=new IntersectionObserver(function(entries){inView=!!entries[0]&&entries[0].isIntersecting;},{threshold:.18});
    observer.observe(rail);
  }else{inView=true;}
  if(!reduced&&rail.children.length>2){
    window.setInterval(function(){if(inView&&!paused&&!document.hidden)advance(1);},7000);
  }
  update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();